import React, { Component } from 'react';
import './ResultsDrawer.scss';
import onClickOutside from 'react-onclickoutside';
import { FormattedAddress } from 'utilities'
import { Checkbox } from '../Wizard2/fieldComponents/Form'
// import reactStringReplace from 'react-string-replace'

class ResultsDrawer extends Component{
  handleClickOutside = (e) => {
    if(this.props.onOutsideClick && this.props.open){
      this.props.onOutsideClick();
    }
  }
  render(){
    const { results, loading=false } = this.props;
    return(
      <div className="results-drawer">
        {
          loading ?
          <span className="loading">Loading...</span>
          :
          results.map((result, i)=>(
            <Result data={result} key={result.SOURCE_ID || i} />
          ))
        }
      </div>
    )
  }
}
export default onClickOutside(ResultsDrawer)

export class Result extends Component {
  static defaultProps = {
    element: 'div'
  }
  onClick = () => {
    if (!this.props.selectable) {
      if (this.props.onClick) {
        this.props.onClick(this.props.data)
      }
    } else {
      if (this.props.onSelectToggled) {
        this.props.onSelectToggled(!this.props.isSelected)
      }
    }
  }
  render() {
    const {
      className = '',
      children,
      data,
      highlight,
      selectable,
      isSelected,
      onSelectToggled
    } = this.props
    const disabled = !!data.DISABLED
    return (
      <this.props.element
        type="button"
        className={'stacked-data-result ' + className}
        onClick={!disabled ? this.onClick : undefined}
        disabled={disabled}
      >
        <div className="flex-row">
          {selectable ? (
            <div className="result-checkbox-wrapper wizard">
              <Checkbox
                aria-label="Select this result"
                value={isSelected}
                onChange={(checked, e) => {
                  e.stopPropagation()
                  onSelectToggled(checked, e)
                }}
              />
            </div>
          ) : null}
          <div className="flex-column">
            {children}
            <ResultLine type="h1" highlight={highlight} value={data.HEADER1} />
            <ResultLine type="subtitle" highlight={highlight} value={data.HEADER2} />
            {data &&
              (data.SECTIONS || []).map((section, i) => (
                <React.Fragment key={i}>
                  <ResultLine type="h2" highlight={highlight} value={section.label} />
                  {section.lines && (
                    <p className="lines">
                      {section.lines.map(({ line }, j) => (
                        <ResultLine type="line" highlight={highlight} value={line} key={j} />
                      ))}
                    </p>
                  )}
                </React.Fragment>
              ))}
          </div>
        </div>
      </this.props.element>
    )
  }
}

class ResultLine extends Component{
  getByType = () => {
    const { type, value } = this.props;
    switch (type) {
      case 'address':
        return value ? <FormattedAddress value={value} className='value' /> : "None"
      case 'h1':
        return <span className='primary'>{value}</span>
      case 'h2':
        return <span className='secondary'>{value}</span>
      case 'subtitle':
        return <span className="subtitle">{value}</span>
      case 'line':
        return <span className='value'>{value}</span>
      default:
        return <span>{value}</span>
    }
  }
  render(){
    const value = this.getByType();
    return(
      value
    )
  }
}
